import React, { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { getPageRoute, getPageTitle } from "../../store/layoutUI";
import LeftMenu from "../../../components/Menu";
import Menu from "../../components/Header/Menu";
import TopMenu from "../../components/Header/TopMenu";
import Breadcrumb from "./Bredcrumb";
import WcagPopup from "../../../Wcag/WcagPopup";
import OnScreenKeyBoard from "../../../Wcag/OnScreenKeyBoard";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

const Layout = () => {
    const [scriptLoadingState, setScriptLoadingState] = useState('IDLE');
    const [wcagShowHide, setWcagShowHide] = useState(false)
    const [smartNav, setSmartNav] = useState(false)
    const [keyboardShowHide, setKeyboardShowHide] = useState(false);
    const [input, setInput] = useState("");
    const [layout, setLayout] = useState("default");
    const [tabOpenStatus, setTabOpenStatus] = useState(false)
    const keyboard = useRef();


    useEffect(() => {
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = '/assets/js/argon.js';
        script.onload = function () {
            setScriptLoadingState('LOADED');
        };
        script.onerror = function () {
            setScriptLoadingState('FAILED');
        };
        document.body.appendChild(script);
    }, []);

    const handleWcagModalShowHide = () => {
        setWcagShowHide(prev => !prev)
    };

    const handleModalShowHide = () => {

    }

    const handleNavigation = () => {
        handleModalShowHide();
        setSmartNav(prev => !prev)
    };

    const getVirtualKeyBoard = () => {
        const vr = document.body.classList.contains("INDvirtualKeyboard");
        if (vr) return "block";
        return "none";
    };

    const handleKeyboardShowHide = () => {
        setKeyboardShowHide(!keyboardShowHide);
    }

    const onChange = input => {
        setInput(input);
        console.log("Input changed", input);
    };

    const handleShift = () => {
        const newLayoutName = layout === "default" ? "shift" : "default";
        setLayout(newLayoutName);
    };

    const onKeyPress = button => {
        console.log("Button pressed", button);

        /**
         * If you want to handle the shift and caps lock buttons
         */
        if (button === "{shift}" || button === "{lock}") handleShift();
    };

    const onChangeInput = event => {
        const input = event.target.value;
        setInput(input);
        keyboard.current.setInput(input);
    };

    const toggleMenu = (val) => {
        // console.log("val", val)
        setTabOpenStatus(val)
    }

    return <>
        <div className="col-md-12">
            <TopMenu />
        </div>
        <LeftMenu onClickToggle={toggleMenu}/>

        <div className="main-content h-100" id="panel">

            <div
                style={{
                    height: "85vh",
                    overflowY: "auto",
                    paddingRight: "15px",
                }}
                id="layout-scroll-wrapper"
            >
                {/* <h1 className="visually-hidden">{input || "Application"}</h1> */}
                <div className="col-md-12">
                    <div className="d-flex justify-content-center"
                        style={{
                            //backgroundColor: "#fdc300",
                            borderBottomLeftRadius: "0px",
                            borderBottomRightRadius: "50px",
                        }}
                    >
                        <Menu onClickToggle={toggleMenu} tabOpenStatus={tabOpenStatus}/>
                    </div>

                </div>
                <div
                    style={{
                        position: "fixed",
                        right: "-5%",
                        top: "92%",
                        zIndex: "99",
                        cursor: "pointer",
                    }}
                >
                    <img
                        onClick={handleWcagModalShowHide}
                        src="/assets/img/wcagIcon.png"
                        alt="Web Content Accessibility Guidelines Image Button"
                        className="btn w-25 p-1 btn-sm btn-default"
                        title="Web Content Accessibility Guidelines (WCAG)"
                    />
                </div>
                {!tabOpenStatus &&
                    <>
                        <Breadcrumb />
                        <Outlet />
                    </>
                }
                <br />
                <br />
                <br />
            </div>
        </div>
        <WcagPopup
            showHide={wcagShowHide}
            handleModalShowHide={handleWcagModalShowHide}
            handleNavigation={handleNavigation}
        ></WcagPopup>

        <OnScreenKeyBoard
            keyboardShowHide={keyboardShowHide}
            handleKeyboardShowHide={handleKeyboardShowHide}
        ></OnScreenKeyBoard>

        <div
            style={{
                display: `${getVirtualKeyBoard()}`,
                position: "fixed",
                bottom: "0px",
                boxShadow: "#c8c8c8 0px 0px 15px 5px",
                border: "20px solid #000000",
                zIndex: "9999",
                width: "100%",
            }}
        >
            <input
                value={input}
                placeholder={"Tap on the virtual keyboard to start"}
                onChange={onChangeInput}
                className="form-control"
                aria-label="Tap on the virtual keyboard to start"
            />
            <Keyboard
                keyboardRef={r => (keyboard.current = r)}
                layoutName={layout}
                onChange={onChange}
                onKeyPress={onKeyPress}
            />
        </div>
    </>

}


export default Layout;
